import { render } from "./AgencySingle.vue?vue&type=template&id=4397bc1a&scoped=true"
import script from "./AgencySingle.vue?vue&type=script&lang=js"
export * from "./AgencySingle.vue?vue&type=script&lang=js"

import "./AgencySingle.vue?vue&type=style&index=0&id=4397bc1a&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4397bc1a"]])

export default __exports__